const { makeStyles } = require("@mui/styles");

const useStyles = makeStyles({
  input: {
    color: "black",
    opacity: 1,
    "&::placeholder": {
      color: "black",
      opacity: 0.8,
    },
  },
});

export default useStyles;
